module.exports = __webpack_public_path__ + "static/infuraShirt2-9c9586f75701ad96e55aea1d6b0b2cb0.jpg";